module.exports = __webpack_public_path__ + "assets/blog/images/soeg_i_beskeder.webp";